import { IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { textLabels } from '../../constants';
import { SolutionCashflow } from '../../types/interfaces';

const GROUPS = {
  cleaning_gains: 'Cleaning Gains ($)',
  capex: 'CAPEX ($)',
  opex: 'OPEX ($)',
} as const;

const quote = (value: string) => `"${value.replace(/"/g, '""')}"`;

const buildCashflowCSV = (cashflow: SolutionCashflow) => {
  const groupRow = [''];
  const columnRow = ['Year'];
  const columns: number[][] = [];
  (Object.keys(GROUPS) as (keyof typeof GROUPS)[]).forEach((group) => {
    const details = Object.entries(cashflow.details![group]);
    details.forEach(([name, values], i) => {
      groupRow.push(i === 0 ? GROUPS[group] : '');
      columnRow.push((textLabels as Record<string, string>)[name] ?? name);
      columns.push(values);
    });
    if (details.length > 1) {
      groupRow.push('');
      columnRow.push('Total');
      columns.push(cashflow[group]);
    }
  });
  const rows = cashflow.years.map((year, idx) => [String(year), ...columns.map((values) => String(values[idx]))]);
  return [groupRow.map(quote), columnRow.map(quote), ...rows].map((row) => row.join(';')).join('\n');
};

type Props = {
  cashflow: SolutionCashflow;
  fileName: string;
};

const DownloadCashflowButton = ({ cashflow, fileName }: Props) => {
  const download = () => {
    const blob = new Blob([buildCashflowCSV(cashflow)], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Tooltip title="Download detailed cashflow (CSV)">
      <IconButton onClick={download}>
        <DownloadIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default DownloadCashflowButton;
